import React, { ReactNode, useState, useEffect } from 'react';

import { useList } from '../../hooks/Request/useList';
import { useBudgetDetails } from '../../providers/hooks/useBudgetDetails';
import { useUtils } from '../../hooks/useUtils';

import RequestStatCard from "../../components/Cards/RequestStatCard";
import LatestRequestCard from "../../components/Cards/LatestRequestCard";
import NewRequestCard from '../Cards/NewRequestCard';
import WhiteListedRequestCard from '../Cards/WhiteListedRequestCard';
import ApprovedRequestCard from '../Cards/ApprovedRequestCard';
import DeclinedRequestCard from '../Cards/DeclinedRequestCard';
import OrderedRequestCard from '../Cards/OrderedRequestCard';
import PurchasedRequestCard from '../Cards/PurchasedRequestCard';
import DeliveredRequestCard from '../Cards/DeliveredRequestCard';
import RequestIconStatCard from '../Cards/RequestIconStatCard';

const AdminDashboard: React.FC = () => {
    const [showList, setShowList] = useState(1);

    const listToShow = () => {
        if (showList == 1) {
            return <LatestRequestCard />
        }

        if (showList == 2) {
            return <NewRequestCard />
        }

        if (showList == 3) {
            return <ApprovedRequestCard />
        }

        if (showList == 4) {
            return <WhiteListedRequestCard />
        }

        if (showList == 5) {
            return <OrderedRequestCard />
        }

        if (showList == 6) {
            return <PurchasedRequestCard />
        }

        if (showList == 7) {
            return <DeliveredRequestCard />
        }

        if (showList == 8) {
            return <DeclinedRequestCard />
        }
    }
    
    const requestList = useList();
    const budgetDetails = useBudgetDetails();
    const helperUtils = useUtils();

    useEffect(() => {
        // budgetDetails?.fetchBudgetDetails();
        requestList?.fetchList();
    }, []);
    return (
        <>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-4 md:gap-6 xl:grid-cols-6 2xl:gap-2.5">
                <div onClick={() => setShowList(1)} className="cursor-pointer">
                    <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.allRequestListCount ? requestList?.allRequestListCount.toString() : "0"} label={"All"} bgColour="bg-slate-500"/>
                </div>
                <div onClick={() => setShowList(2)}  className="cursor-pointer">
                    <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.newRequestListCount ? requestList?.newRequestListCount.toString() : "0"} label={"New"} bgColour="bg-request-status-new"/>
                </div>
                <div onClick={() => setShowList(3)}  className="cursor-pointer">
                    <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.approvedRequestListCount ? requestList?.approvedRequestListCount.toString() : "0"} label={"Approved"} bgColour="bg-request-status-approved"/>
                </div>
                <div onClick={() => setShowList(4)}  className="cursor-pointer">
                    <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.waitListedListCount ? requestList?.waitListedListCount.toString() : "0"} label={"Waitlisted"} bgColour="bg-request-status-waitlisted"/>
                </div>
                <div onClick={() => setShowList(5)}  className="cursor-pointer">
                    <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.orderedListCount ? requestList?.orderedListCount.toString() : "0"} label={"Ordered"} bgColour="bg-request-status-ordered"/>
                </div>
                <div onClick={() => setShowList(6)}  className="cursor-pointer">
                    <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.purchasedListCount ? requestList?.purchasedListCount.toString() : "0"} label={"Purchased"} bgColour="bg-request-status-purchased"/>  
                </div>
                <div onClick={() => setShowList(7)}  className="cursor-pointer">
                    <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.deliveredListCount ? requestList?.deliveredListCount.toString() : "0"} label={"Delivered"} bgColour="bg-request-status-delivered"/>                                        
                </div>
                <div onClick={() => setShowList(8)}  className="cursor-pointer">
                    <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.declinedListCount ? requestList?.declinedListCount.toString() : "0"} label={"Declined"} bgColour="bg-request-status-declined"/>
                </div>
                <div>
                    <RequestIconStatCard  totalRequest={100} numberOfRequest={budgetDetails?.budgetSpent ? helperUtils.convertToMoney(budgetDetails?.budgetSpent) : "0"} label={"Total Spent"} bgColour="bg-slate-400"/>
                </div>
                <div>
                    <RequestIconStatCard  totalRequest={100} numberOfRequest={budgetDetails?.budgetRemaining ? helperUtils.convertToMoney(budgetDetails?.budgetRemaining) : "0"} label={"Total Remaining"} bgColour="bg-slate-400"/>
                </div>
            </div>

            <div className="mt-4 grid grid-cols-12 gap-4 md:mt-6 md:gap-6 2xl:mt-7.5 2xl:gap-7.5">
                { listToShow() }
            </div>
        </>        
    );
};

export default AdminDashboard;